<template>
      <v-dialog v-model="dialog" persistent max-width="800px">
        <v-form v-model="valid" ref="form" lazy-validation>
      <v-card>
        <v-toolbar dark color="primary elevation-1">
          <v-btn icon @click.native="close" dark>
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>Add Insurance</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn dark text @click.native="save">Save</v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12 sm8 md8>
                <v-text-field v-model="form.name" label="Name" :rules="itemRules" required></v-text-field>
              </v-flex>
              <v-flex xs12 sm4 md4>
                <v-text-field v-model="form.cn" label="Company nr"></v-text-field>
              </v-flex>
              <v-flex xs10>
                <g-input
                  :required="true"
                  id="address"
                  @change="setAddress"
                  @placechanged="setPlace"
                  :label="'Address'"
                  :clearable="true"
                  :delete="true"
                  :rules="itemRules"
                  :error="adress_notValid"
                ></g-input>
                <span v-if="adress_notValid" class="input-group__details error--text">Address is uncomplete, select a completed address.</span>
              </v-flex>
              <v-flex xs2>
                <v-text-field v-model="form.postbox" label="Postbox"></v-text-field>
              </v-flex>

              <v-flex xs12 sm4 md4>
                <v-text-field v-model="form.tel" label="Tel"></v-text-field>
              </v-flex>

              <v-flex xs12 sm4 md4>
                <v-text-field v-model="form.email" label="Email" :rules="emailRules" required></v-text-field>
              </v-flex>

              <v-flex xs12 sm4 md4>
                <v-text-field v-model="form.bank_account" label="Bank account"></v-text-field>
              </v-flex>
              <v-flex xs12 sm4 md4>
                <v-text-field v-model="form.min10km" label="Forfait (-10km)"></v-text-field>
              </v-flex>
              <v-flex xs12 sm4 md4>
                <v-text-field v-model="form.plus10km" label="Forfait (+10km)"></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field v-model="form.comment" label="Comment"></v-text-field>
              </v-flex>

            </v-layout>
          </v-container>
          <small>*indicates required field</small>
        </v-card-text>
      </v-card>
      </v-form>
    </v-dialog>
</template>

<script>
  import gInput from '@/components/googlemaps/gInput';
  import FormMixin from '@/mixins/formvalid'
  export default {
    mixins: [FormMixin],
    components: {
      'g-input': gInput
    },
    props: ['dialog', 'form'],
    data () {
      return {
        valid: false,
        adress_notValid: false
      }
    },
    methods: {
      save () {
        if (this.$refs.form.validate()) {
          if (this.form.address && this.form.zip && this.form.city) {
            this.$emit('save', this.form);
          } else {
            console.log('check your address');
          }
        }
      },
      close () {
        this.$emit('close');
      },
      reset () {
        this.$refs.form.reset();
      },
      setAddress (v) {
        this.form.fullAddress = v;
      },
      setPlace (v) {
        if (v.street_number && v.postal_code && v.route && v.locality) {
          this.form.address = v.route + ' ' + v.street_number;
          this.form.zip = v.postal_code;
          this.form.city = v.locality || '';
          this.adress_notValid = false;
        } else {
          this.adress_notValid = true;
          this.form.fullAddress = this.form.address = this.form.zip = this.form.city = '';
        }
        console.log(v);
      },
      init (v) {
        if (v) {
          this.$nextTick(() => { 
            this.$refs.form.reset();
          });
        }
      }
    },
    watch: {
      dialog (value) {
        this.init(value);
      }
    }
  }
</script>

